module.exports = __webpack_public_path__ + "bb017f0170163e4b835c17f7f7e830b9.png";